import { render, staticRenderFns } from "./PatientRegistry.view.vue?vue&type=template&id=12bdc942"
import script from "./PatientRegistry.view.vue?vue&type=script&lang=js"
export * from "./PatientRegistry.view.vue?vue&type=script&lang=js"
import style0 from "./PatientRegistry.view.vue?vue&type=style&index=0&id=12bdc942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports